<template>
  <v-dialog :model-value="isVisible" width="600" @close="closeDialog" persistent>
    <v-card>
      <v-card-title class="d-flex flex-row">
        <h4 class="text-capitalize" data-testid="yard-message-driver-dialog-title">
          {{ t('yard.dialogs.yardViewMessageDriverDialog.headers.messageTheDriver') }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn icon="mdi-close" variant="text" density="comfortable" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <template v-if="assetVisit?.id && spotCode && spotAreaName">
          <p>
            {{
              t(
                'yard.dialogs.yardViewMessageDriverDialog.messages.theDriverWillReceiveASmsMessageNotifyingTheNewAssignedSpot'
              )
            }}
          </p>

          <v-chip class="my-4">
            <v-icon size="small" class="mr-2">mdi-comment-text-outline</v-icon>
            {{ message }}
          </v-chip>
        </template>
        <template v-else>
          <p>
            {{
              t(
                'yard.dialogs.yardViewMessageDriverDialog.messages.invalidSpotAssignmentNoMessageWillBeSent'
              )
            }}
          </p>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          variant="outlined"
          @click="closeDialog"
          data-testid="yard-message-driver-dialog-cancel">
          {{ t('yard.dialogs.yardViewMessageDriverDialog.buttons.skipMessage') }}
        </v-btn>
        <v-btn
          class="bg-primary"
          @click="submit"
          data-testid="yard-message-driver-dialog-submit"
          :disabled="!assetVisit?.id">
          {{ t('global.buttons.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, defineComponent, ref, onMounted } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { useEventHub } from '@/composables';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewMessageDriverDialog',

  setup() {
    const { t } = useI18n();
    const yardStore = useYard();
    const eventHub = useEventHub();
    const isVisible = ref(false);

    const assetVisitRef = ref(null);
    const spotCode = ref(null);
    const spotAreaName = ref(null);

    const message = computed(
      () =>
        `${t('yard.dialogs.yardViewMessageDriverDialog.messages.youveBeenAssignedTo')} ${
          spotAreaName.value
        } - ${spotCode.value}`
    );

    const submit = () => {
      yardStore.messageDriver(assetVisitRef.value.id, message.value);
      yardStore.trackMixpanelEvent(yardStore.MixPanelEvent.MESSAGE_DRIVER, {
        assetVisit: assetVisitRef.value,
        entryPoint: 'Live Yard View Panel',
        metadata: {
          message: message.value,
          appointmentId: assetVisitRef.value.appointmentId
        }
      });
      closeDialog();
    };

    const closeDialog = () => {
      isVisible.value = false;
      assetVisitRef.value = null;
      spotCode.value = null;
      spotAreaName.value = null;
    };

    onMounted(() => {
      eventHub.$on(
        yardStore.SPOT_ASSIGNMENT_CHANGED,
        ({ assetVisit, newSpotCode, newSpotAreaName }) => {
          if (
            assetVisit?.id &&
            newSpotCode &&
            newSpotAreaName &&
            !yardStore.isAssetContainer(assetVisit)
          ) {
            assetVisitRef.value = assetVisit;
            spotCode.value = newSpotCode;
            spotAreaName.value = newSpotAreaName;

            isVisible.value = true;
          }
        }
      );
    });

    return {
      t,
      submit,
      assetVisit: assetVisitRef,
      spotCode,
      spotAreaName,
      isVisible,
      closeDialog,
      message
    };
  }
});
</script>
